export default __webpack_public_path__ + "static/media/IGT.4bdb9dff.jpg";